import * as React from 'react';

const VerticalDots12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6 11.25A1.125 1.125 0 1 1 6 9a1.125 1.125 0 0 1 0 2.25M6 3A1.125 1.125 0 1 1 6 .75 1.125 1.125 0 0 1 6 3m0 4.125a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25"
  }
));
VerticalDots12.Size = 12;
VerticalDots12.Title = "VerticalDots";

export { VerticalDots12 as default };
